import { initializeApp } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'

const firebaseConfig = {
  apiKey: 'AIzaSyBJgaiZpscJJ33gbpFm8_MwxDTFIPDq5Kc',
  authDomain: 'site-jarder.firebaseapp.com',
  projectId: 'site-jarder',
  storageBucket: 'site-jarder.firebasestorage.app',
  messagingSenderId: '241683345003',
  appId: '1:241683345003:web:a793d3d15b74fe0d850b2e',
  measurementId: 'G-Z740DWQXLP',
}

export const firebaseApp = initializeApp(firebaseConfig)
export const analytics = getAnalytics(firebaseApp)
